<template>
  <div class="app-container">
    <transition name="el-zoom-in-top">
      <div class="filter-container">
        <el-card
          shadow="never"
          class="box-card"
          style="margin-bottom: 20px;"
        >订单数量：{{ TotalOrder }}</el-card>
        <el-card class="custom-card" shadow="never">
          <el-row :gutter="10">
            <el-col :lg="2">
              场地名称：<br>
              <el-input
                :placeholder="$t('table.fieldName')"
                v-model="listQuery.fieldName"
                class="filter-item"
              />
            </el-col>
            <el-col :lg="2">
              设备唯一标识号：<br>
              <el-input
                :placeholder="$t('table.Identity')"
                v-model="listQuery.identity"
                class="filter-item"
              />
            </el-col>
            <el-col :lg="2">
              取包手机：<br>
              <el-input
                v-model="listQuery.telPhone"
                placeholder="请输入"
                class="filter-item"
              />
            </el-col>
            <el-col :lg="2">
              订单编号：<br>
              <el-input
                v-model="listQuery.orderNo"
                placeholder="请输入订单编号"
                class="filter-item"
              />
            </el-col>
            <el-col :lg="2">
              订单类型：<br>
              <el-select
                v-model="listQuery.orderType"
                :placeholder="$t('table.OrderType')"
                clearable
                class="filter-item custom-width"
              >
                <el-option
                  v-for="item in ordertypes"
                  :key="item.value"
                  :label="item.value"
                  :value="item.type"
                />
              </el-select>
            </el-col>
            <el-col :lg="2">
              订单状态：<br>
              <el-select
                v-model="listQuery.orderState"
                placeholder="请选择订单状态"
                clearable
                class="filter-item custom-width"
              >
                <el-option
                  v-for="item in orderStates"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-col>
            <el-col :lg="2">
              订单种类：<br>
              <el-select
                v-model="listQuery.orderTypea"
                placeholder="请选择订单种类："
                clearable
                class="filter-item custom-width"
              >
                <el-option
                  v-for="item in orderTypea"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-col>
            <el-col :lg="3">
              开始时间：<br>
              <el-date-picker
                v-model="listQuery.startTime"
                :clearable="false"
                :placeholder="$t('table.startTime')"
                class="filter-item custom-width"
                type="date"
              />
            </el-col>
            <el-col :lg="3">
              结束时间：<br>
              <el-date-picker
                v-model="listQuery.endTime"
                :clearable="false"
                :placeholder="$t('table.endTime')"
                class="custom-width filter-item"
                type="date"
              />
            </el-col>
            <el-col :lg="2">
              <br>
              <el-button
                v-waves
                round
                class="filter-item"
                type="primary"
                icon="el-icon-search"
                @click="handleFilter"
              >{{ $t('table.search') }}</el-button>
            </el-col>
            <el-col :lg="2">
              <template v-if="list">
                <!-- <el-select
            v-model="bookType"
            :placeholder="$t('table.saveType')"
            clearable
            class="filter-item"
            style="width: 130px"
          >
            <el-option v-for="item in bookTypeList" :key="item" :label="item" :value="item"/>
          </el-select> -->
                <br>
                <el-button
                  v-waves
                  :loading="downloadLoading"
                  round
                  class="filter-item"
                  type="primary"
                  icon="el-icon-download"
                  @click="handleDownload"
                >{{ $t('table.export') }}</el-button>
              </template>
            </el-col>
          </el-row>
        </el-card>

      </div>
    </transition>
    <transition name="el-zoom-in-top">
      <div class="filter-container">
        <el-table
          v-loading="listLoading"
          :key="list.id"
          :data="list"

          fit
          stripe
          highlight-current-row
          style="width: 100%;"
        >
          <el-table-column :label="$t('table.id')" align="center" width="50px">
            <template slot-scope="scope">
              <span>{{ (scope.$index + 1) + ((listQuery.pageIndex - 1) * listQuery.pageSize) }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.OrderNo')" width="200px" align="center">
            <template slot-scope="scope">
              <el-link type="primary" @click="handleRefund(scope.row)">{{ scope.row.OrderInfo.OrderNo }}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="收费模式" width="200px" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.OrderInfo.ChargingMode | fileterChangedDuration }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column v-if="roleId === 1" :label="`是否隐藏订单`" width="150px" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.OrderInfo.IsVisible === 'N'?'隐藏':'不隐藏' }}</span>
            </template>
          </el-table-column> -->
          <el-table-column :label="$t('table.fieldName')" width="200px" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.FieldName }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.Identity')" width="200px" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.Identity }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="`是否有押金`" align="center">
            <template slot-scope="scope">
              <span
                v-if="scope.row.OrderInfo.IsDeposit"
              >{{ scope.row.OrderInfo.IsDeposit === 'Y'?'有押金':'无押金' }}</span>
              <span v-else>无押金</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.PayMoney') + '(元)'" width="100px" align="center">
            <template slot-scope="scope">
              <span
                v-if="scope.row.OrderInfo.PayMoney || scope.row.OrderInfo.PayMoney === 0"
              >{{ scope.row.OrderInfo.PayMoney }}</span>
              <span v-else>0</span>
            </template>
          </el-table-column>
          <el-table-column :label="`押金金额(元)`" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.OrderInfo.Deposit">{{ scope.row.OrderInfo.Deposit }}</span>
              <span v-else>0</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.boxNo')" width="100px" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.OrderInfo.BoxNo }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.userName')" width="150px" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.UserInfo.LoginNo }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column :label="$t('table.telPhone')" width="150px" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.UserInfo.TelPhone }}</span>
            </template>
          </el-table-column> -->
          <el-table-column :label="$t('table.OrderType')" width="100px" align="center">
            <template slot-scope="scope">
              <span
                v-if="scope.row.OrderInfo.OrderType"
              >{{ scope.row.OrderInfo.OrderType === 'box' ? '使用箱子' : scope.row.OrderInfo.OrderType === 'member' ? '会员充值' : '--' }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column :label="`寄存手机号`" width="100px" align="center">
            <template slot-scope="scope">
              <span
                v-if="scope.row.OrderInfo.TakeTel.length === 11"
              >{{ scope.row.OrderInfo.TakeTel }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="`寄存密码`" width="100px" align="center">
            <template slot-scope="scope">
              <span
                v-if="scope.row.OrderInfo.TakePwd.length === 4 || scope.row.OrderInfo.TakePwd.length === 6"
              >{{ scope.row.OrderInfo.TakePwd }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('table.OrderState')" align="center" width="100px">
            <template slot-scope="scope">
              <span
                v-if="scope.row.OrderInfo.OrderState"
              >{{ scope.row.OrderInfo.OrderState === 'A' ? '进行中' : scope.row.OrderInfo.OrderState === 'D' ? '使用中' : scope.row.OrderInfo.OrderState === 'S' ? '订单结束' : '--' }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="`退款金额(元)`" width="100px" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.OrderInfo.RetCoinMoney">{{ scope.row.OrderInfo.RetCoinMoney }}</span>
              <span v-else>0</span>
            </template>
          </el-table-column>
          <el-table-column :label="`退款状态`" width="100px" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.OrderInfo.RetCoinStatus === 'SUCCESS' ? '退款成功' : (scope.row.OrderInfo.RetCoinStatus === 'ERROR' ? '退款失败' : '') }}</span>
              <!-- <span v-else>0</span> -->
            </template>
          </el-table-column>
          <el-table-column :label="`清理类型`" width="100px" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.OrderInfo.ClearMode | filteClearMode }}</span>
              <!-- <span v-else>0</span> -->
            </template>
          </el-table-column>
          <el-table-column :label="`退款备注`" width="100px" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.OrderInfo.RetCoinMemo">{{ scope.row.OrderInfo.RetCoinMemo }}</span>
              <span v-else>---</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.PayType')" align="center" width="100px">
            <template slot-scope="scope">
              <span>{{ scope.row.OrderInfo.PayType === 'Wx' ? '微信支付' : '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="`存放时间`" align="center" width="180px">
            <template slot-scope="scope">
              <span>{{ scope.row.OrderInfo.StartTime }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.endTime')" align="center" width="180px">
            <template slot-scope="scope">
              <span>{{ scope.row.OrderInfo.EndTime || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="场地分成(元)" align="center" width="180px">
            <template slot-scope="scope">
              <span>{{ scope.row.OrderInfo.FieldProportion || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="代理商分成(元)" align="center" width="180px">
            <template slot-scope="scope">
              <span>{{ scope.row.OrderInfo.AgentProportion || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.autoEndTime')" align="center" width="180px">
            <template slot-scope="scope">
              <span>{{ scope.row.OrderInfo.AutoEndTime }}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('table.actions')"
            align="center"
            width="120px"
            class-name="small-padding fixed-width"
          >
            <template slot-scope="scope">
              <!-- <el-button v-if="calcPermission(permition, 1)" type="primary" @click="detailOrder(scope.row)">{{ $t('table.detail') }}</el-button> -->
              <el-button
                v-if="scope.row.OrderInfo.RetCoinStatus == 'SUCCESS'&& scope.row.serInfo.RetCoinStatus == null"
                type="primary"
                @click="handleConfirmRefund(scope.row)"
              >{{ $t('table.refund') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-card class="custom-card" shadow="never">
          <el-pagination
            v-show="total>0"
            :current-page="listQuery.pageIndex"
            :page-sizes="[10,20,50,100]"
            :page-size="listQuery.pageSize"
            :total="total"
            layout="total, prev, pager, next"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </el-card>
      </div>
    </transition>

    <!-- 退款弹窗 -->
    <el-dialog :visible.sync="refundVisible" title="分订单" width="60%">
      <el-table :data="splitOrderData" fit style="width: 100%">
        <el-table-column label="微信订单编号">
          <template slot-scope="scope">
            <span>{{ scope.row.OrderNo }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户名">
          <template slot-scope="scope">
            <span>{{ scope.row.Name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="寄存手机号">
          <template slot-scope="scope">
            <span>{{ scope.row.Phone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付金额">
          <template slot-scope="scope">
            <span>{{ scope.row.Money }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付时间">
          <template slot-scope="scope">
            <span>{{ scope.row.PayTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否退款">
          <template slot-scope="scope">
            <el-link v-if="scope.row.RetCoinStatus === 'ERROR'" type="danger">退款失败</el-link>
            <el-link v-else-if="scope.row.RetCoinStatus === 'SUCCESS'" type="success">退款成功</el-link>
            <el-link v-else>未退款</el-link>
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作">
          <template slot-scope="scope">
            <template v-if="calcPermission(permition, 2) && scope.row.OrderState ==='D' && scope.row.ChargingMode !== 'Month'">
              <el-link
                v-if="scope.row.flag && (scope.row.RetCoinStatus === 'ERROR' || scope.row.RetCoinStatus === null)"
                type="danger"
                @click="handleConfirmRefund(scope.row)"
              >退款</el-link>
            </template>
          </template>
        </el-table-column> -->
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="refundVisible = false">取 消</el-button>
        <el-button type="primary" @click="refundVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { qryOrderInfo, exportExcel, refund, getSplitOrder } from '@/api/order'
import { qryRoleInfo } from '@/api/baseModule'
// import { parseTime } from '@/utils'
import waves from '@/directive/waves' // 水波纹指令
import moment from 'moment'
export default {
  name: 'Ordermanage',
  directives: {
    waves
  },
  filters: {
    fileterChangedDuration(value) {
      let str = ''
      switch (value) {
        case 'Duration':
          str = '时长'
          break
        case 'Frequency':
          str = '次数'
          break
        case 'Month':
          str = '包月'
          break
        case 'DurationStage':
          str = '次数 + 区间时长'
          break
        case 'Free':
          str = '免费'
          break
      }
      return str
    },
    filteClearMode(val) {
      let str = ''
      switch (val) {
        case 0:
          str = '用户'
          break
        case 1:
          str = '后台'
          break
        case 2:
          str = '自动'
          break
      }
      return str
    }
  },
  data() {
    return {
      refundVisible: false,
      splitOrderData: [],
      orderStates: [
        {
          value: null,
          label: '全部'
        },
        {
          value: 'D',
          label: '使用中'
        },
        {
          value: 'S',
          label: '订单结束'
        }

      ],
      orderTypea: [
        {
          value: null,
          label: '全部'
        },
        {
          value: 'D',
          label: '过滤订单'
        }

      ],
      listQuery: {
        pageIndex: 1,
        pageSize: 10,
        identity: null,
        fieldName: null,
        telPhone: null,
        orderState: null,
        orderType: null,
        orderTypea: null,
        orderNo: null,
        startTime: moment().format('YYYY-MM-DD'),
        endTime: moment().format('YYYY-MM-DD')
      },
      listLoading: true,
      list: [],
      permition: 0,
      total: null,
      ordertypes: [
        {
          value: '全部',
          type: null
        },
        {
          value: '使用箱子',
          type: 'box'
        },
        {
          value: '充值会员',
          type: 'member'
        }
      ],
      TotalMoney: 0,
      TotalOrder: 0,
      VirtualMoney: 0,
      bookType: 'xlsx',
      bookTypeList: ['xlsx', 'csv', 'txt'],
      downloadLoading: false,
      roleId: null,
      url_: process.env.BASE_API
    }
  },
  watch: {
    listQuery: {
      handler(value) {
        console.log(value)
        for (const key in value) {
          if (!value[key]) {
            value[key] = null
          }
        }
      },
      deep: true
    }
  },
  created() {
    const queryList = window.location.href.split('seetuserId=')
    if (queryList.length === 2) {
      this.listQuery.seetuserId = queryList[1]
    }

    this.roleId = this.$store.getters.roles.RoleId
    if (this.$store.state.roleInfo) {
      this.$store.state.roleInfo.LsList[0].RolePrograms.forEach(item => {
        if (this.$route.path === item.ProgramInfo.PgUrl) {
          this.permition = item.Permition
          this.qryOrder()
        }
      })
      // this.$store.state.roleInfo.LsList[0].RolePrograms.forEach(item => {
      //   if (this.$route.path === item.ProgramInfo.PgUrl) {
      //     this.permition = item.Permition
      //     this.qryOrder()
      //   }
      // })
    } else {
      qryRoleInfo({
        rId: this.$store.getters.roles.RoleId
      }).then(response => {
        this.$store.state.roleInfo = response
        response.LsList[0].RolePrograms.forEach(item => {
          if (this.$route.path === item.ProgramInfo.PgUrl) {
            this.permition = item.Permition
            this.qryOrder()
          }
        })
      })
    }
  },
  methods: {
    // 获取场地列表
    qryOrder() {
      qryOrderInfo(this.listQuery).then(request => {
        console.log(request)
        this.list = request.LsList.LsList
        this.TotalMoney = request.TotalMoney
        this.TotalOrder = request.TotalOrder
        this.VirtualMoney = request.VirtualMoney
        this.total = request.LsList.TotalRows
        this.listLoading = false
        console.log(request.LsList)
      })
    },
    // 数据导出
    handleDownload() {
      if (!this.listQuery.startTime) {
        this.$message.error('请选择开始时间')
        return
      }
      if (!this.listQuery.endTime) {
        this.$message.error('请输入结束时间')
        return
      }
      this.downloadLoading = true
      const { startTime, endTime, identity, fieldName, orderType, orderState, orderNo } = this.listQuery
      exportExcel({ startTime, endTime, identity, fieldName, orderType, orderState, orderNo }).then(res => {
        if (res) {
          window.open(this.url_ + res)
          this.downloadLoading = false
        }
      })
      // import('@/vendor/Export2Excel').then(excel => {
      //   const tHeader = ['订单编号', '场地名称', '设备唯一标识号', '是否有押金', '付款金额', '押金金额', '箱号', '用户名', '手机号', '订单类型', '订单状态', '退款金额', '退款状态', '退款备注', '支付方式', '添加时间']
      //   const filterVal = ['OrderNo', 'FieldName', 'Identity', 'IsDeposit', 'PayMoney', 'Deposit', 'BoxNo', 'UserName', 'TelPhone', 'OrderType', 'OrderState', 'RetCoinMoney', 'RetCoinStatus', 'RetCoinMemo', 'PayType', 'StartTime']
      //   const list = this.list
      //   const data = this.formatJson(filterVal, list)
      //   excel.export_json_to_excel({
      //     header: tHeader,
      //     data,
      //     filename: '订单统计',
      //     autoWidth: true,
      //     bookType: this.bookType
      //   })
      //   this.downloadLoading = false
      // })
      this.qryOrder()
    },
    formatJson(filterVal, jsonData) {
      console.log('315', jsonData)
      return jsonData.map(v => filterVal.map(j => {
        console.log(v)
        console.log(j)
        // if (j === Object.keys(v['OrderInfo'])) {
        //   console.log('320', v['OrderInfo'][j])
        //   return v['OrderInfo'][j]
        // } else if (j === Object.keys(v['UserInfo'])) {
        //   return v['UserInfo'][j]
        // } else {
        //   return v[j]
        // }
        for (const iterator of Object.keys(v['OrderInfo'])) {
          if (j === iterator) {
            switch (v['OrderInfo'][j]) {
              case 'A':
                v['OrderInfo'][j] = '新建'
                break
              case 'D':
                v['OrderInfo'][j] = '支付完成'
                break
              case 'S':
                v['OrderInfo'][j] = '订单结束'
                break
            }
            switch (v['OrderInfo'][j]) {
              case 'box':
                v['OrderInfo'][j] = '使用箱子'
                break
              case 'member':
                v['OrderInfo'][j] = '充值会员'
                break
            }
            switch (v['OrderInfo'][j]) {
              case 'Wx':
                v['OrderInfo'][j] = '微信支付'
                break
            }
            switch (v['OrderInfo'][j]) {
              case 'SUCCESS':
                v['OrderInfo'][j] = '退款成功'
                break
              case 'ERROR':
                v['OrderInfo'][j] = '退款失败'
                break
            }
            switch (v['OrderInfo'][j]) {
              case 'Y':
                v['OrderInfo'][j] = '有押金'
                break
              case 'N':
                v['OrderInfo'][j] = '无押金'
                break
            }
            return v['OrderInfo'][j]
          }
        }
        for (const iterator1 of Object.keys(v['UserInfo'])) {
          if (j === iterator1) {
            return v['UserInfo'][j]
          }
        }
        // if (j === 'timestamp') {
        //   return parseTime(v[j])
        // } else {
        return v[j]
        // }
      }))
    },
    // 退款订单列表
    handleRefund(item) {
      console.log(item)
      this.getRefundList(item, 1)
      this.refundVisible = true
    },
    // 获取退款订单
    getRefundList(item, type) {
      const orderId = type ? item.OrderInfo.OrderId : item.OrderId
      getSplitOrder({ orderId, type: 'weixin' }).then(res => {
        if (type) {
          res.forEach(data => {
            data.Name = item.UserInfo.UserName
            data.Phone = item.OrderInfo.TakeTel
            data.OrderState = item.OrderInfo.OrderState
            data.ChargingMode = item.OrderInfo.ChargingMode
          })
          res[res.length - 1].flag = true
        }

        this.splitOrderData = res
        console.log(res)
      })
    },
    // 退款确认
    handleConfirmRefund(item) {
      console.log(item)
      refund({ orderNo: item.OrderInfo.OrderNo }).then(res => {
        if (res) {
          this.$message.success('退款成功')
          // this.getRefundList(item, 0)
          // this.getOrderList()
          // this.refundVisible = false
          this.qryOrder()
        }
      })
    },
    handleSizeChange(e) {
      this.listQuery.pageSize = e
      this.qryOrder()
    },
    handleCurrentChange(e) {
      this.listQuery.pageIndex = e
      this.qryOrder()
    },
    handleFilter() {
      this.listQuery.pageIndex = 1
      // this.listQuery.name = this.listQuery.key
      this.qryOrder()
    },
    refund() {
      alert('暂不支持退款')
    }
  }
}
</script>
<style lang="less" scoped>
.custom-width{
  width: 100%;
}
</style>
